import { render, staticRenderFns } from "./PurchaseSelect.vue?vue&type=template&id=35b97ee5"
import script from "./PurchaseSelect.vue?vue&type=script&lang=js"
export * from "./PurchaseSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports